{
  "endTime": "Čas ukončenia",
  "startTime": "Čas začiatku",
  "time": "Čas"
}
